import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';
import {Constants} from '../../constants';
import {ICondition} from '../../model/condition.interface';
import {RulesService} from '../../rules.service';

@Component({
  selector: 'app-condition',
  templateUrl: './condition.component.html',
  styleUrls: ['./condition.component.scss']
})
export class ConditionComponent implements OnInit {

  public searchBoxTitle = Constants.THING_SEARCHBOX_TITLE;
  @Input() columnData;
  @Output() editMode: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteColumn: EventEmitter<any> = new EventEmitter<any>();
  constructor(private ruleService: RulesService) { }

  ngOnInit() {

  }
  get condition() {
    return this.columnData ? this.columnData.condition : {};
  }
  onClick($event) {
    this.editMode.emit($event);
  }
  delete() {
    this.deleteColumn.emit(true);
  }
  toggleOperator() {
    this.columnData.logicalConnector = this.columnData.logicalConnector === Constants.LOGICAL_AND ?
      Constants.LOGICAL_OR : Constants.LOGICAL_AND;
  }
  isOrOperator() {
    return this.columnData.logicalConnector === Constants.LOGICAL_OR;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/condition/condition.component.ts